import React from 'react';
import OnboardingStepVisual from './OnboardingStepVisual';

interface Props {
    readonly currentStep?: number;
    readonly totalSteps?: number;
    readonly stepNames?: object;
}

function OnboardingPanelTitle({
    currentStep = null,
    totalSteps = null,
    stepNames = null,
}: Props) {
    if (currentStep && !totalSteps) {
        throw new Error('If `currentStep` is provided then `totalSteps` is also required.');
    }
    const sanitizedCurrentStep = Math.abs(currentStep);

    return (
        <div className="flex flex-col sm:flex-row items-center sm:items-end justify-between mb-3">
            <img src="/logo/mark.png" alt="graphic" className="h-16" />
            <div className="flex flex-row mb-2">
                {stepNames ? (
                    <OnboardingStepVisual
                        currentStep={sanitizedCurrentStep}
                        totalSteps={totalSteps}
                        stepNames={stepNames}
                    />
                ) : ''}
            </div>
        </div>
    );
}

export default OnboardingPanelTitle;
